<template>
  <div class="card bg-warning">
    <!-- <button @click="test">hola</button> -->
    <div class="card-header text-light">
      <!-- <h5 class="font-weight-bold mb-0">Administrador de membresías</h5> -->
      <p class="mb-0 text-uppercase font-weight-bold">filtros</p>
    </div>
    <div class="card-body">
      <div
        :class="
          showExtraFilters ? 'filters-wrapper--expanded' : 'filters-wrapper'
        "
      >
        <div class="row mb-0 pb-0">
          <div class="col-md-4 pb-0">
            <div class="px-4 py-2 d-flex flex-column card">
              <p
                for=""
                class="text-uppercase text-secondary font-weight-bold mb-1"
              >
                Familias
              </p>
              <el-select
                size="small"
                multiple
                class="select-success"
                placeholder="TODAS"
                v-model="filter.family"
              >
                <el-option
                  v-for="(family, i) in computedFamiliesCatalog"
                  :key="i"
                  :value="family._id"
                  :label="family.nombre"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-4 pb-0">
            <div class="px-4 py-2 d-flex flex-column card">
              <p
                for=""
                class="text-uppercase text-secondary font-weight-bold mb-1"
              >
                Sub-Familias
              </p>
              <el-select
                size="small"
                multiple
                class="select-success"
                placeholder="TODAS"
                v-model="filter.subFamily"
              >
                <el-option
                  v-for="(subFamily, i) in computedSubFamiliesCatalog"
                  :key="i"
                  :value="subFamily._id"
                  :label="subFamily.nombre"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-4 pb-0 overflow-hidden">
            <div class="px-4 py-2 d-flex flex-column card">
              <p
                for=""
                class="text-uppercase text-secondary font-weight-bold mb-1"
              >
                Planes
              </p>
              <el-select
                size="small"
                multiple
                class="select-success"
                placeholder="TODOS"
                v-model="filter.plan"
              >
                <el-option
                  v-for="(plan, i) in computedPlansCatalog"
                  :key="i"
                  :value="plan._id"
                  :label="plan.nombre"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!-- v-if="showExtraFilters" -->
        <template>
          <div class="row" :class="!showExtraFilters ? 'hidden' : ''">
            <div class="col-md-4 my-2">
              <div class="px-4 py-2 d-flex flex-column card">
                <p
                  for=""
                  class="text-uppercase text-secondary font-weight-bold mb-1"
                >
                  Estados
                </p>
                <el-select
                  size="small"
                  multiple
                  class="select-success"
                  placeholder="TODOS"
                  v-model="filter.status"
                >
                  <el-option
                    v-for="(cat, i) in statusCatalog"
                    :key="i"
                    :value="cat"
                    :label="cat"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-4 my-2">
              <div class="px-4 py-2 d-flex flex-column card">
                <p
                  for=""
                  class="text-uppercase text-secondary font-weight-bold mb-1"
                >
                  Sucursales
                </p>
                <el-select
                  size="small"
                  multiple
                  class="select-success"
                  placeholder="TODAS"
                  v-model="filter.branches"
                >
                  <el-option
                    v-for="(branch, i) in branches"
                    :key="i"
                    :value="branch._id"
                    :label="branch.nombreSucursal"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-4 my-2">
              <div class="px-4 py-2 d-flex flex-column card">
                <p
                  for=""
                  class="text-uppercase text-secondary font-weight-bold mb-1"
                >
                  Turnos
                </p>
                <el-select
                  size="small"
                  multiple
                  class="select-success"
                  placeholder="TODOS"
                  v-model="filter.shift"
                >
                  <el-option
                    v-for="(plan, i) in shiftsCatalog"
                    :key="i"
                    :value="plan._id"
                    :label="plan.nombre"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="px-4 py-2 d-flex flex-column card">
                <p
                  for=""
                  class="text-uppercase text-secondary font-weight-bold mb-1 mx-auto"
                >
                  Fecha de inicio
                </p>
                <el-date-picker
                  type="daterange"
                  size="small"
                  range-separator=":"
                  v-model="beginingDatePicker"
                  start-placeholder="Desde"
                  end-placeholder="Hasta"
                  class="d-none d-md-inline-flex mx-auto"
                  :unlink-panels="true"
                  format="dd-MM-yyyy"
                  value-format="dd-MM-yyyy"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="px-4 py-2 d-flex flex-column card">
                <p
                  for=""
                  class="text-uppercase text-secondary font-weight-bold mb-1 mx-auto"
                >
                  Fecha de Vencimiento
                </p>
                <el-date-picker
                  type="daterange"
                  size="small"
                  v-model="dueDatePicker"
                  range-separator=":"
                  start-placeholder="Desde"
                  end-placeholder="Hasta"
                  unlink-panels
                  class="d-none d-md-inline-flex mx-auto"
                  format="dd-MM-yyyy"
                  value-format="dd-MM-yyyy"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center card-footer">
      <button
        class="btn rounded-pill shadow-sm"
        :class="showExtraFilters ? 'btn-info' : 'btn-success'"
        @click="toggleExtraFilters"
      >
        {{ showExtraFilters ? "Ocultar Filtros" : "Más filtros"
        }}<i
          :class="showExtraFilters ? 'fa-minus' : 'fa-plus'"
          class="fa fa-plus fa-lg ml-1"
          aria-hidden="true"
        ></i>
      </button>
      <button
        class="btn-info btn rounded-pill shadow-sm mx-2"
        @click="updateFilter"
      >
        ver resultado <i class="fa fa-search fa-lg" aria-hidden="true"></i>
      </button>
      <button
        class="btn-info btn col-auto rounded-pill my-auto shadow-sm"
        @click="exportSelection"
      >
        Exportar
        <i class="fa fa-cloud-download fa-lg" aria-hidden="true"></i>
      </button>
      <!-- <button class="btn-info btn col-auto rounded-pill mt-0 mx-4 shadow">
          descargar <i class="fa fa-arrow-down fa-lg" aria-hidden="true"></i>
        </button>
        <button class="btn-info btn col-auto rounded-pill mt-0 shadow">
          editar <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
        </button> -->
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Dropdown from "src/components/UIComponents/Dropdown.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";
import Loading from "src/components/Dashboard/Layout/LoadingMainPanel.vue";
import { CollapseItem, Collapse } from "src/components/UIComponents";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Tooltip,
} from "element-ui";
export default {
  name: "filters",
  props: {
    statusCatalog: {
      type: Array,
      default: () => {
        return ["VIGENTE", "PAGADO", "PENDIENTE", "CONGELADO"];
      },
    },
    plansCatalog: {
      type: Array,
      default: () => {
        return [
          { nombre: "Plan PlaceHolder 1", _id: 1 },
          { nombre: "Plan PlaceHolder 2", _id: 2 },
          { nombre: "Plan PlaceHolder 3", _id: 3 },
        ];
      },
    },
    familiesCatalog: {
      type: Array,
      default: () => {
        return [];
      },
    },
    subFamiliesCatalog: {
      type: Array,
      default: () => {
        return [];
      },
    },
    shiftsCatalog: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    Dropdown,
    CollapseItem,
    Collapse,
    Loading,
    PSwitch,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
  },
  data() {
    return {
      filter: {
        status: [],
        branches: [],
        plan: [],
        family: [],
        subFamily: [],
        shift: [],
      },
      dueDatePicker: [],
      beginingDatePicker: [],
      branches: [],
      showExtraFilters: false,
    };
  },
  watch: {
    filter: {
      handler() {
        this.emitCurrentFilters();
      },
      immediate: true,
      deep: true,
    },
    dueDatePicker() {
      this.emitCurrentFilters();
    },
    beginingDatePicker() {
      this.emitCurrentFilters();
    },
    branches() {
      this.emitCurrentFilters();
    },
  },
  computed: {
    computedPlansCatalog() {
      // console.log("computedPlansCatalog");
      if (this.filter.subFamily.length > 0) {
        // console.log("this.filter.subFamily");
        return this.plansCatalog.filter((cat) => {
          return this.filter.subFamily.some((id) => cat.idSubFamilia === id);
        });
      } else if (this.filter.family.length > 0) {
        // console.log("this.filter.family");
        return this.plansCatalog.filter((cat) => {
          return this.filter.family.some((id) => cat.familia === id);
        });
      }
      return this.plansCatalog; // Devuelve el catálogo completo si no hay filtro de familia
    },
    computedFamiliesCatalog() {
      // if (this.filter.family.length > 0) {
      //   console.log('this.filter.family')
      //   return this.familiesCatalog.filter((cat) => {
      //     return this.filter.family.some((id) => cat.familia === id);
      //   });
      // }
      return this.familiesCatalog;
    },
    computedSubFamiliesCatalog() {
      if (this.filter.family.length > 0) {
        // console.log("this.filter.family");
        return this.subFamiliesCatalog.filter((cat) => {
          return this.filter.family.some((id) => cat.idFamilia === id);
        });
      }
      return this.subFamiliesCatalog;
    },
  },
  methods: {
    test() {
      console.log(this.filter);
      console.log(this.dueDatePicker);
      console.log(this.beginingDatePicker);
    },
    exportSelection() {
      this.$emit("export");
    },
    toggleExtraFilters() {
      this.showExtraFilters = !this.showExtraFilters;
    },
    updateFilter() {
      let dateFilter = {};
      if (
        this.dueDatePicker &&
        (this.dueDatePicker[0] || this.dueDatePicker[1])
      ) {
        dateFilter.endGTE = this.dueDatePicker[0];
        dateFilter.endLTE = this.dueDatePicker[1];
      }
      if (
        this.beginingDatePicker &&
        (this.beginingDatePicker[0] || this.beginingDatePicker[0])
      ) {
        dateFilter.beginingGTE = this.beginingDatePicker[0];
        dateFilter.beginingLTE = this.beginingDatePicker[1];
      }

      this.$emit("filter", { ...this.filter, dateFilter: dateFilter });
    },
    emitCurrentFilters() {
      let dateFilter = {};
      if (
        this.dueDatePicker &&
        (this.dueDatePicker[0] || this.dueDatePicker[1])
      ) {
        dateFilter.endGTE = this.dueDatePicker[0];
        dateFilter.endLTE = this.dueDatePicker[1];
      }
      if (
        this.beginingDatePicker &&
        (this.beginingDatePicker[0] || this.beginingDatePicker[0])
      ) {
        dateFilter.beginingGTE = this.beginingDatePicker[0];
        dateFilter.beginingLTE = this.beginingDatePicker[1];
      }

      this.$emit("currentFilters", { ...this.filter, dateFilter: dateFilter });
    },
  },
  beforeMount() {
    this.branches = JSON.parse(sessionStorage.getItem("xxxwypt5ip"));
    if (this.$store.getters.getMembershipsDDtag) {
      this.pagination.currentFilter = this.$store.getters.getMembershipsDDtag;
    }
    // console.log("this.currentFilter");
    // console.log(this.currentFilter);
  },
};
</script>

<style>
.filters-wrapper {
  max-height: 120px;
  overflow: hidden;
  box-shadow: inset 0px -10px 10px -10px rgba(0, 0, 0, 0.5); /* Sombra interior */
  transition: max-height 5s ease-in-out;
}
.filters-wrapper--expanded {
  max-height: auto; /* Puedes ajustar esto a la altura máxima deseada */
  box-shadow: none; /* Elimina la sombra interior cuando está expandido */
  animation: expandHeight 5s ease-in-out forwards;
}
.hidden {
  opacity: 0.5;
}
</style>
